(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-night-view-feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.ai-night-view-section');
    if (!section) return;
    window.initAnimatedText('.ai-night-view-title');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription_benefits"] && !Shopify.designMode) return;
  try {
    
// 暂时不需要 JavaScript

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription_guarantee"] && !Shopify.designMode) return;
  try {
    
// 如需添加JavaScript功能可在此处添加

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription_signup"] && !Shopify.designMode) return;
  try {
    
// 视频自动播放检测与回退处理
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.sub-signup-video');
  videos.forEach(video => {
    // 设置正确的海报图片
    if (window.innerWidth <= 767 && "{{ section.settings.product_video_mobile.preview_image.src | image_url: width: 800 }}") {
      video.poster = "{{ section.settings.product_video_mobile.preview_image.src | image_url: width: 800 }}";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
